import { Component } from '@angular/core'
import { LoginService } from '../../login/shared/login.service'

@Component({
  selector: 'app-session-expired-page',
  templateUrl: './session-expired-page.component.html',
  styleUrls: ['./session-expired-page.component.scss'],
})
export class SessionExpiredPageComponent {
  constructor(private readonly loginService: LoginService) {}

  onLoginButtonClick() {
    this.loginService.backToLogin().subscribe()
  }
}
